import React, {
    useEffect, useState,
} from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import {
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useIntl } from 'react-intl';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import CustomTypography from '../../components/Typography/CustomTypography';
import CleanableInput from '../../components/Input/CleanableInput';
import { TooltipIcon } from '../../components/Icons/Icon';
import UploadButton from '../../components/Button/UploadButton';
import DetailSeminarStyle from '../../assets/jss/pages/detailSeminarCompanyStyle';
import Popper from '../../components/Popper/Popper';
import Button from '../../components/Button/CustomButton';
import FormDialog from '../../components/Dialog/FormDialog';
import Validation from '../../common/Validation';
import InputHasUnit from './inputHasUnit';
import { FREE_LOGIN } from '../../common/Constants';
import CustomTextSelector from '../../selectors/CustomText';

const useStyles = makeStyles(DetailSeminarStyle);

const titleDialog = (classes, matches, openPopper, popperTarget, handleOpenPopper, setOpenPopper, title) => (
    <Box>
        <CustomTypography variant="h6" bold color="info">
            {title || 'セミナー情報編集'}
            <IconButton onClick={handleOpenPopper} className={classes.tooltipStyle}>
                <TooltipIcon color="#E17A3F" />
            </IconButton>
        </CustomTypography>
        <Popper
            size={matches ? '300px' : '380px'}
            isArrow
            isOpen={openPopper}
            placement="bottom"
            target={popperTarget}
            handleClose={() => setOpenPopper(false)}
        >
            <Box>
                <CustomTypography bold className={classes.note}>
                    登録のメリット
                </CustomTypography>
                <Box paddingTop={1} paddingBottom={1}>
                    <GridContainer>
                        <GridItem xs={2} md={2} className={classes.number}>
                            <span>
                                1
                            </span>
                        </GridItem>
                        <GridItem xs={10} md={10} className={classes.noteContent}>
                            題目は直接入力して下さい
                        </GridItem>
                    </GridContainer>
                </Box>
                <Box paddingTop={1} paddingBottom={1}>
                    <GridContainer>
                        <GridItem xs={2} md={2} className={classes.number}>
                            <span>
                                2
                            </span>
                        </GridItem>
                        <GridItem xs={10} md={10} className={classes.noteContent}>
                            講演者写真の登録して下さい
                            <br />
                            （のせいない場合は音声のみの講演会となります
                        </GridItem>
                    </GridContainer>
                </Box>
                <Box paddingTop={1} paddingBottom={1}>
                    <GridContainer>
                        <GridItem xs={2} md={3} className={classes.number}>
                            <span>
                                3
                            </span>
                        </GridItem>
                        <GridItem xs={10} md={9} className={classes.noteContent}>
                            コンテンツは音声データのみの登録となります。
                        </GridItem>
                    </GridContainer>
                </Box>
            </Box>
        </Popper>
    </Box>
);
const mediaType = { audio: '1', video: '2' };
const costType = { free: '1', fee: '2' };

export default function DetailSeminar(props) {
    const {
        isOpen, handleClose, detailSeminar, handleEditSeminar,
        errors, eventInfo,
    } = props;
    const classes = useStyles();

    const [openPopper, setOpenPopper] = useState(false);
    const [popperTarget, setPopperTarget] = useState(null);
    const [btnUploadMedia, setBtnUploadMedia] = useState({});
    const [inputMoney, setInputMoney] = useState(false);
    const [validateResults, setValidateResults] = useState({});
    const [errorsUpload, setErrorUpload] = useState(false);
    const [changeDataUpLoad, setChangeDataUpLoad] = useState({ changeImage: false, changeMedia: false, changeDocument: false });
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const [params, setParams] = useState({
        media_type: '0',
        cost_type: '0',
    });
    const intl = useIntl();
    const customText = useSelector(CustomTextSelector.createGetCustomText());

    useEffect(() => {
        if (detailSeminar) {
            const type = detailSeminar.cost > 0 ? costType.fee : costType.free;
            setParams({
                ...detailSeminar,
                cost_type: type,
                mediaPreview: detailSeminar.media,
                documentPreview: detailSeminar.document,
                imagePreview: detailSeminar.speaker_img && detailSeminar.speaker_img.concat('?=', new Date().getTime().toString()),
            });
            setChangeDataUpLoad({ changeImage: false, changeMedia: false, changeDocument: false });
        }
    }, [detailSeminar]);

    // Control display button upload file when choose media_type
    useEffect(() => {
        let type = '';
        let disabled = true;
        if (`${params.media_type}` === mediaType.video) {
            type = 'video';
            disabled = false;
        }
        if (`${params.media_type}` === mediaType.audio) {
            type = 'audio';
            disabled = false;
        }
        setBtnUploadMedia({ type, disabled });
    }, [params.media_type]);

    // Control display input money when choose cost_type
    useEffect(() => {
        if (`${params.cost_type}` === costType.fee) {
            setInputMoney(false);
        } else {
            setInputMoney(true);
        }
    }, [params.cost_type]);

    useEffect(() => {
        if (errors && errors.code === 'BAD_REQUEST') {
            if (!errors.message) {
                setValidateResults({
                    ...validateResults,
                    ...errors,
                });
            }
        }
    }, [errors]);

    const handleOpenPopper = (event) => {
        setOpenPopper(true);
        setPopperTarget(event.currentTarget);
    };

    const handleUploadImage = (file) => {
        handleSetParams('speaker_img', file);
        setChangeDataUpLoad({ ...changeDataUpLoad, changeImage: true });
    };

    const handleUploadDocument = (file) => {
        setErrorUpload(false);
        handleSetParams('document', file);
        setChangeDataUpLoad({ ...changeDataUpLoad, changeDocument: true });
    };
    const handleVideoOrAudio = (file) => {
        handleSetParams('media', file);
        setChangeDataUpLoad({ ...changeDataUpLoad, changeMedia: true });
    };
    const handleSetParams = (field, valueChange) => {
        setParams((prevParams) => ({ ...prevParams, [field]: valueChange }));
    };

    const createDataToCallApi = () => {
        const defaultDataToCallApi = {
            seminar_id: params.id,
            data: {
                title: checkUndefined(params.title),
                speaker: checkUndefined(params.speaker),
                speaker_img: (changeDataUpLoad.changeImage && params.speaker_img) || '',
                speaker_profile: params.speaker_profile,
                content: checkUndefined(params.content),
                media: (changeDataUpLoad.changeMedia && params.media) || '',
                media_type: ((params.isChangeMediaType || changeDataUpLoad.changeMedia) && params.media_type) || '',
                document: (changeDataUpLoad.changeDocument && params.document) || '',
                document_link: checkUndefined(params.document_link),
                survey_link: checkUndefined(params.survey_link),
                link_contact: checkUndefined(params.link_contact),
                limit: -1,
            },
        };
        let dataToCallApi = defaultDataToCallApi;

        if (eventInfo.free_seminar) {
            dataToCallApi = defaultDataToCallApi;
        }
        if (!_.isEmpty(eventInfo.languages)) {
            dataToCallApi = {
                ...dataToCallApi,
                data: {
                    ...dataToCallApi.data,
                    title_en: checkUndefined(params.title_en),
                    speaker_en: checkUndefined(params.speaker_en),
                    content_en: checkUndefined(params.content_en),
                },
            };
        }
        if (!eventInfo.free_seminar) {
            dataToCallApi = {
                ...dataToCallApi,
                data: {
                    ...dataToCallApi.data,
                    cost: 0,
                },
            };
        }
        if (!eventInfo.free_seminar && eventInfo.has_shopping_cart) {
            dataToCallApi = {
                ...dataToCallApi,
                data: {
                    ...dataToCallApi.data,
                    cost: params.cost_type === costType.fee ? Number(checkUndefined(`${params.cost}`)) : 0,
                    limit: Number(checkUndefined(`${params.limit}`)),
                },
            };
        }

        return dataToCallApi;
    };
    const handleCloseDialog = () => {
        handleClose();
        setParams({});
        setChangeDataUpLoad({ changeImage: false, changeMedia: false, changeDocument: false });
        setValidateResults({});
    };
    const handleSubmit = () => {
        if (validate() && !errorsUpload) {
            const dataToCallApi = createDataToCallApi();
            handleEditSeminar(dataToCallApi);
        }
    };
    const validate = () => {
        const validateRules = {
            title: [
                () => Validation.isNotEmpty(params.title),
                () => Validation.validateMaxLength(params.title, 50),
            ],
            speaker: [
                () => Validation.isNotEmpty(params.speaker),
                () => Validation.validateMaxLength(params.speaker, 50),
            ],
            speaker_profile: [
                () => Validation.validateMaxLength(params.speaker_profile, 300),
            ],
            content: [
                () => Validation.isNotEmpty(params.content),
                () => Validation.validateMaxLength(params.content, 300),
            ],
            media: [
                () => Validation.isNotEmpty(params.media),
            ],
            document_link: [
                () => Validation.validateMaxLength(params.document_link, 500),
                () => Validation.isValidUrl(params.document_link),
            ],
            survey_link: [
                () => Validation.validateMaxLength(params.survey_link, 500),
                () => Validation.isValidUrl(params.survey_link),
            ],
            link_contact: [() => Validation.validateMaxLength(params.link_contact, 500),
                () => Validation.validateEmail(params.link_contact)],
        };

        if (!_.isEmpty(eventInfo.languages)) {
            validateRules.title_en = [
                () => Validation.isNotEmpty(params.title_en),
                () => Validation.validateLatin(params.title_en),
                () => Validation.validateMaxLength(params.title_en, 50),
            ];
            validateRules.speaker_en = [
                () => Validation.isNotEmpty(params.speaker_en),
                () => Validation.validateLatin(params.speaker_en),
                () => Validation.validateMaxLength(params.speaker_en, 50),
            ];
            validateRules.content_en = [
                () => Validation.isNotEmpty(params.content_en),
                () => Validation.validateLatin(params.content_en),
                () => Validation.validateMaxLength(params.content_en, 300),
            ];
        }

        if (!eventInfo.free_seminar && eventInfo.has_shopping_cart) {
            validateRules.limit = [
                () => Validation.isNotEmpty(params.limit > 0 ? params.limit : ''),
                () => Validation.isInt(params.limit),
            ];
            if (params.cost_type === costType.fee) {
                validateRules.cost = [
                    () => Validation.isNotEmpty(params.cost > 0 ? params.cost : ''),
                    () => Validation.isPositiveNumbers(params.cost_type),
                    () => Validation.isInt(params.cost),
                ];
            } else {
                validateRules.cost = [
                    () => Validation.isNotEmpty(params.cost),
                    () => Validation.isPositiveNumbers(params.cost_type),
                    () => Validation.isInt(params.cost),
                ];
            }
        }

        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    const calculateLimitDurationByType = () => {
        if (btnUploadMedia.type === 'video') {
            return eventInfo.max_vtime_seminar;
        }

        if (btnUploadMedia.type === 'audio') {
            return eventInfo.max_atime_seminar;
        }

        return 0;
    };

    const actionsButton = () => (
        <Box style={{ margin: 'auto' }}>
            <Button
                autoFocus
                gradient
                onClick={handleSubmit}
                size="md"
                color="success"
                className={classes.btn}
                style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
            >
                {intl.formatMessage({ id: 'save' })}
            </Button>
            <Button
                autoFocus
                gradient
                onClick={handleCloseDialog}
                size="md"
                color="danger"
                style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
            >
                {intl.formatMessage({ id: 'cancel' })}
            </Button>
        </Box>
    );
    const getLastTextUrl = (url) => {
        if (url) {
            const arr = url.split('/');
            return arr[arr.length - 1];
        }
        return '';
    };

    return (
        <>
            <FormDialog
                isOpen={isOpen}
                handleClose={handleCloseDialog}
                title={titleDialog(classes, matches, openPopper, popperTarget, handleOpenPopper, setOpenPopper, customText?.content?.screen_name?.seminar_info_edit)}
                actions={actionsButton()}
            >
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.conference_room || '会議室'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} md={9}>
                        <CustomTypography bold>
                            {params.room}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.dates || '開催日'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} md={9}>
                        <CustomTypography bold>
                            {params.date && format(new Date(params.date), 'yyyy/MM/dd')}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.open_time || '開催時間'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} md={9}>
                        <CustomTypography bold>
                            {params.stime}
                            {' '}
                            ~
                            {' '}
                            {params.etime}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold required>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.lecture_name || '講演名'}（和文）`
                                : (customText?.content?.field_name?.lecture_name || '講演名')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={5} md={5}>
                        <CleanableInput
                            defaultValue={params.title}
                            onChange={(valueInput) => handleSetParams('title', valueInput)}
                            error={!!validateResults.title}
                            helperText={validateResults.title
                                ? intl.formatMessage(
                                    { id: validateResults.title.message },
                                    { maxLength: 50 },
                                ) : ''}
                        />
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} md={3}>
                            <CustomTypography bold required>
                                {`${customText?.content?.field_name?.lecture_name || '講演名'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                            <CleanableInput
                                defaultValue={params.title_en}
                                onChange={(valueInput) => handleSetParams('title_en', valueInput)}
                                error={!!validateResults.title_en}
                                helperText={validateResults.title_en
                                    ? intl.formatMessage(
                                        { id: validateResults.title_en.message },
                                        { maxLength: 50 },
                                    ) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold required>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.speaker || '講演者'}（和文）`
                                : (customText?.content?.field_name?.speaker || '講演者')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={5} md={5}>
                        <CleanableInput
                            defaultValue={params.speaker}
                            onChange={(valueInput) => handleSetParams('speaker', valueInput)}
                            error={!!validateResults.speaker}
                            helperText={validateResults.speaker
                                ? intl.formatMessage(
                                    { id: validateResults.speaker.message },
                                    { maxLength: 50 },
                                ) : ''}
                        />
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} md={3}>
                            <CustomTypography bold required>
                                {`${customText?.content?.field_name?.speaker || '講演者'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                            <CleanableInput
                                defaultValue={params.speaker_en}
                                onChange={(valueInput) => handleSetParams('speaker_en', valueInput)}
                                error={!!validateResults.speaker_en}
                                helperText={validateResults.speaker_en
                                    ? intl.formatMessage(
                                        { id: validateResults.speaker_en.message },
                                        { maxLength: 50 },
                                    ) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.speaker_photo || '講演者写真'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} md={9}>
                        <UploadButton
                            text={customText?.content?.button_name?.speaker_photo_button || '講演者写真'}
                            type="image"
                            onChange={(file) => handleUploadImage(file)}
                            imagePreview={params.imagePreview}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.speaker_profile || '講演者プロフィール'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} md={9}>
                        <CleanableInput
                            defaultValue={params.speaker_profile}
                            onChange={(valueInput) => handleSetParams('speaker_profile', valueInput)}
                            isMultiline
                            row="3"
                            error={!!validateResults.speaker_profile}
                            helperText={validateResults.speaker_profile
                                ? intl.formatMessage(
                                    { id: validateResults.speaker_profile.message },
                                    { maxLength: 300 },
                                ) : ''}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold required>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.lecture_content || '講演内容'}（和文）`
                                : (customText?.content?.field_name?.lecture_content || '講演内容')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} md={9}>
                        <CleanableInput
                            defaultValue={params.content}
                            onChange={(valueInput) => handleSetParams('content', valueInput)}
                            isMultiline
                            row="3"
                            error={!!validateResults.content}
                            helperText={validateResults.content
                                ? intl.formatMessage(
                                    { id: validateResults.content.message },
                                    { maxLength: 300 },
                                ) : ''}
                        />
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} md={3}>
                            <CustomTypography bold required>
                                {`${customText?.content?.field_name?.lecture_content || '講演内容'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={9}>
                            <CleanableInput
                                defaultValue={params.content_en}
                                onChange={(valueInput) => handleSetParams('content_en', valueInput)}
                                isMultiline
                                row="3"
                                error={!!validateResults.content_en}
                                helperText={validateResults.content_en
                                    ? intl.formatMessage(
                                        { id: validateResults.content_en.message },
                                        { maxLength: 300 },
                                    ) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                )}
                {!eventInfo.free_seminar && eventInfo.has_shopping_cart && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} md={3}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.maximum_number_applicants || '申込最大人数'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem
                            xs={12}
                            sm={5}
                            md={3}
                        >
                            <InputHasUnit
                                defaultValue={`${params.limit === -1 ? 0 : params.limit}`}
                                onChange={(valueInput) => handleSetParams('limit', valueInput)}
                                error={!!validateResults.limit}
                                helperText={validateResults.limit
                                    ? intl.formatMessage(
                                        { id: validateResults.limit.message },
                                    ) : ''}
                                unit="人"
                                minValue={0}
                                maxValue={100}
                            />
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold required>
                            {customText?.content?.field_name?.audio_video_registration || '音声・動画登録'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} md={9}>
                        <RadioGroup
                            aria-label="media_type"
                            name="media_type"
                            row
                            value={`${params.media_type}`}
                            onChange={(e) => setParams({
                                ...params,
                                media_type: e.target.value,
                                isChangeMediaType: Number(detailSeminar.media_type) !== Number(e.target.value),
                            })}
                        >
                            <FormControlLabel
                                value={mediaType.video}
                                control={<Radio color="primary" />}
                                label={<CustomTypography>動画</CustomTypography>}
                                style={{ paddingRight: '30px' }}
                            />
                            <FormControlLabel
                                value={mediaType.audio}
                                control={<Radio color="primary" />}
                                label={<CustomTypography>音声</CustomTypography>}
                            />
                        </RadioGroup>
                        <UploadButton
                            text=""
                            type={btnUploadMedia.type}
                            onChange={(file) => handleVideoOrAudio(file)}
                            disabled={btnUploadMedia.disabled}
                            namePreview={getLastTextUrl(params.mediaPreview)}
                            limitDuration={calculateLimitDurationByType()}
                        />
                        <FormHelperText error className="MuiFormHelperText-contained">
                            {validateResults.media
                                ? intl.formatMessage({ id: validateResults.media.message }) : ''}
                        </FormHelperText>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.lecture_materials || '講演資料'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} md={9}>
                        <UploadButton
                            text=""
                            type="document"
                            onChange={(file) => handleUploadDocument(file)}
                            namePreview={getLastTextUrl(params.documentPreview)}
                            errors={(value) => setErrorUpload(value)}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.document_request_reception || '資料請求受付'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={5} md={5}>
                        <CleanableInput
                            defaultValue={params.document_link}
                            onChange={(valueInput) => handleSetParams('document_link', valueInput)}
                            error={!!validateResults.document_link}
                            helperText={validateResults.document_link
                                ? intl.formatMessage(
                                    { id: validateResults.document_link.message },
                                    { maxLength: 500 },
                                ) : ''}
                        />
                        <CustomTypography>
                            ＊ＵＲＬを入力してください。
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.questionnaire || 'アンケート'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={5} md={5}>
                        <CleanableInput
                            defaultValue={params.survey_link}
                            onChange={(valueInput) => handleSetParams('survey_link', valueInput)}
                            error={!!validateResults.survey_link}
                            helperText={validateResults.survey_link
                                ? intl.formatMessage(
                                    { id: validateResults.survey_link.message },
                                    { maxLength: 500 },
                                ) : ''}
                        />
                    </GridItem>
                </GridContainer>
                {/* {FREE_LOGIN.FREE_ALL.CODE !== eventInfo.free_login && ( */}
                {!eventInfo.free_seminar && eventInfo.has_shopping_cart && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} md={3}>
                            <CustomTypography bold required>
                                {customText?.content?.field_name?.price || '料金'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem
                            xs={12}
                            md={9}
                        >
                            <RadioGroup
                                aria-label="cost_type"
                                name="cost_type"
                                row
                                value={`${params.cost_type}`}
                                onChange={(e) => setParams({
                                    ...params,
                                    cost_type: e.target.value,
                                })}
                            >
                                <FormControlLabel
                                    value={costType.free}
                                    control={<Radio color="primary" />}
                                    label={<CustomTypography>無料</CustomTypography>}
                                    style={{ paddingRight: '30px' }}
                                />
                                <FormControlLabel
                                    value={costType.fee}
                                    control={<Radio color="primary" />}
                                    label={<CustomTypography>有料</CustomTypography>}
                                />
                            </RadioGroup>
                        </GridItem>
                        <GridItem xs={12} md={3} />
                        <GridItem xs={12} sm={5} md={3}>
                            <InputHasUnit
                                defaultValue={params.cost}
                                onChange={(valueInput) => handleSetParams('cost', valueInput)}
                                unit="円"
                                disabled={inputMoney}
                                minValue={0}
                            />
                            <FormHelperText error className="MuiFormHelperText-contained">
                                {validateResults.cost
                                    ? intl.formatMessage({ id: validateResults.cost.message }) : ''}
                            </FormHelperText>
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.inquiries || 'お問合せ'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={5} md={5}>
                        <CleanableInput
                            defaultValue={params.link_contact}
                            onChange={(valueInput) => handleSetParams('link_contact', valueInput)}
                            error={!!validateResults.link_contact}
                            helperText={validateResults.link_contact
                                ? intl.formatMessage(
                                    { id: validateResults.link_contact.message },
                                    { maxLength: 500 },
                                ) : ''}
                        />
                        <CustomTypography>
                            ＊メールアドレスを入力してください。
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
            </FormDialog>
        </>
    );
}

DetailSeminar.defaultProps = {
    isOpen: false,
    detailSeminar: {},
    errors: {},
    eventInfo: {},
};

DetailSeminar.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    handleEditSeminar: PropTypes.func.isRequired,
    detailSeminar: PropTypes.oneOfType([() => null, PropTypes.array]),
    errors: PropTypes.PropTypes.oneOfType([() => null, PropTypes.array]),
    eventInfo: PropTypes.PropTypes.oneOfType([() => null, PropTypes.object]),
};
